import { SvgIconProps } from "@material-ui/core"
import Check from "@material-ui/icons/Check"
import ChevronLeft from "@material-ui/icons/ChevronLeft"
import ChevronRight from "@material-ui/icons/ChevronRight"
import Close from "@material-ui/icons/Close"
import CloseOutlined from "@material-ui/icons/CloseOutlined"
import DescriptionOutlined from "@material-ui/icons/DescriptionOutlined"
import ExpandMore from "@material-ui/icons/ExpandMore"
import InfoOutlined from "@material-ui/icons/InfoOutlined"
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown"
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight"
import Language from "@material-ui/icons/Language"
import MailOutline from "@material-ui/icons/MailOutline"
import PhoneInTalk from "@material-ui/icons/PhoneInTalk"
import SettingsOutlined from "@material-ui/icons/SettingsOutlined"
import VisibilityOutlined from "@material-ui/icons/VisibilityOutlined"
import { t } from "i18next"
import React from "react"

const iconMap = {
  Check,
  ChevronLeft,
  ChevronRight,
  Close,
  CloseOutlined,
  DescriptionOutlined,
  ExpandMore,
  InfoOutlined,
  KeyboardArrowDown,
  KeyboardArrowRight,
  Language,
  MailOutline,
  PhoneInTalk,
  SettingsOutlined,
  VisibilityOutlined,
}

export type MuiIconCollections = keyof typeof iconMap

interface CustomIconProps extends SvgIconProps {
  name?: MuiIconCollections
}

export const MaterialIcon = (props: CustomIconProps) => {
  const { name, ...rest } = props

  if (name && iconMap[name]) {
    return React.createElement(iconMap[name], {
      ...rest,
    })
  }

  return <>{t("iconNotFound")}</>
}
